export enum AutomationName {
  onCommunicationComplete = 'onCommunicationComplete',
}
